module.exports = __webpack_public_path__ + "img/shang1.0871673c.png";